import React, { useEffect, useState } from 'react';
import SearchBox from '../searchBox/SearchBox';
import styles from './Deals.module.scss';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Button, Grid, Paper } from '@material-ui/core';
import CustomButton from '../layout/customButton/CustomButton';
import LeadsTable from '../leads/LeadsTable';
import Appointments from '../dashboard/appointments/Appointments';
import DealStatus from '../dashboard/dealStatus/DealStatus';
import { connect } from 'react-redux';
import {
	clearDealStatusFilterBy,
	getLeads,
	setDealsSection,
} from '../../redux/deals/action';
import { getVisibleClients } from '../../redux/clients/actions';
import Modal from '../layout/modal/Modal';
import addLeads from '../../api/SendEmails/addLeads.api';
import LeadsForm from '../sendEmail/forms/LeadsForm';
import LeadsSection from './leadsSection/LeadsSection';
import PurchasesSection from './purchasesSection/PurchasesSection';
import FilterButton from '../FilterButton/FilterButton';
import { closeModal, openModal } from '../../redux/modals/action';
import FilterLeads from './FilterLeadsModal/FilterLeads';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import { clearFilters, removeFilter } from '../../redux/filter/actions';
import getSalesAgentById from '../../api/SalesAgents/getSalesAgentById.api';
import CustomTab from '../CustomTab/CustomTab';
import PendingStatus from './purchasesSection/PendingStatus/PendingStatus';
import { useHistory } from 'react-router';
import Loading from '../layout/loading/Loading';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../../constants/stripeIdentification';
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const Deals = ({
	getLeads,
	leads,
	loading,
	modals,
	user,
	openModal,
	closeModal,
	leadsFilter,
	clearFilters,
	removeFilter,
	filterDealBy,
	clearDealStatusFilterBy,
	setDealsSection,
	section,
}) => {
	const [search, setSearch] = useState('');
	const [salesAgentId, setSalesAgentId] = useState('allSalesAgents');
	const [filteredLead, setFilteredLead] = useState();
	const [filterByDate, setFilterByDate] = useState('All');
	const [checked, setChecked] = useState();
	const [dealStatusTab, setDealStatusTab] = useState(0);
	const [filterArray, setFilterArray] = useState([]);

	var history = useHistory();

	useEffect(() => {
		getLeads();
	}, []);

	useEffect(() => {
		var array = [];

		console.log('leadsFilter', leadsFilter);

		for (var key in leadsFilter) {
			console.log('keykeykey', key);
			if (leadsFilter[key] !== 'default' && key !== 'agent') {
				array.push({ label: key, value: leadsFilter[key] });
			}

			if (key === 'agent' && leadsFilter[key] !== 'default') {
				console.log('leadsFilter', leadsFilter[key]);

				array.push({
					label: key,
					value: leadsFilter[key]['salesAgentName'],
				});
			}
		}

		console.log('arrayarrayarray', array);

		setFilterArray(array);
	}, [leadsFilter]);

	const handleChange = (e) => {
		setSearch(e.target.value);
	};

	const handleSection = (e) => {
		var data = e.currentTarget.dataset.section;

		console.log('data', data);

		if (data === 'leads') {
			clearDealStatusFilterBy();
			setDealsSection(data);
		} else if (data === 'purchases') {
			clearFilters('leadsFilter');
			setDealsSection(data);
		}
	};

	const handleDeleteChip = (chipToDelete, item) => {
		console.log('ittem', item);
		removeFilter('leadsFilter', item);
		setFilterArray((chips) =>
			chips.filter((chip, index) => index !== chipToDelete)
		);
	};

	return (
		<>
			{loading && <Loading />}
			<div className={styles.deals_page}>
				<Grid container className={styles.header_group}>
					<Grid item className={styles.title_group} xs={9}>
						<Grid container className={styles.left_group}>
							<Grid item xl={1} lg={1} md={12} sm={12}>
								<h1 className={styles.title}>
									Deals{' '}
									{section === 'leads' && (
										<span>
											<Button
												className={styles.leads_filter}
												startIcon={<FilterListIcon />}
												onClick={() =>
													openModal('filterLeads')
												}
											>
												Filter
											</Button>
										</span>
									)}
								</h1>
							</Grid>
							<Grid
								item
								xl={11}
								lg={11}
								md={12}
								sm={12}
								container
								className={styles.filter_parent}
								justifyContent='space-between'
							>
								{section === 'leads' && (
									<Grid
										item
										className={styles.filter_button}
										xs={10}
										container
									>
										<div className={styles.chipsGroup}>
											{filterArray.map((chip, index) => {
												return (
													<Chip
														key={index}
														label={chip.value}
														onDelete={() =>
															handleDeleteChip(
																index,
																chip.label
															)
														}
														variant='outlined'
														className={
															styles.chip_item
														}
														deleteIcon={
															<CloseIcon />
														}
													/>
												);
											})}
										</div>
									</Grid>
								)}

								{section === 'purchases' && filterDealBy && (
									<Grid
										item
										className={styles.filter_button}
										xs={10}
										container
									>
										<div>
											<Chip
												label={filterDealBy}
												onDelete={() =>
													clearDealStatusFilterBy()
												}
												variant='outlined'
												className={styles.chip_item}
												deleteIcon={<CloseIcon />}
												style={{ marginLeft: 20 }}
											/>
										</div>
									</Grid>
								)}

								<Grid
									item
									className={styles.clearAllWrapper}
									xs={2}
								>
									{filterArray.length > 0 && (
										<Grid item>
											<div
												className={styles.clear_button}
												onClick={() => {
													clearFilters('leadsFilter');
													closeModal('filterLeads');
												}}
											>
												Clear All
											</div>
										</Grid>
									)}
									{section === 'purchases' && filterDealBy && (
										<Grid item>
											<div
												className={styles.clear_button}
												onClick={() => {
													clearDealStatusFilterBy();
												}}
											>
												Clear All
											</div>
										</Grid>
									)}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
						className={styles.search_group}
						xs={3}
						justifyContent='flex-end'
						container
					>
						<div className={styles.search_wrapper}>
							<SearchBox
								placeholder='Search'
								handleChange={handleChange}
							/>
						</div>
					</Grid>
				</Grid>

				<hr className={styles.divider} />

				<div className={styles.selector_group}>
					<div
						className={`${styles.selector_btn}  ${
							section === 'leads' && styles.active
						}`}
						data-section='leads'
						onClick={(e) => handleSection(e)}
						data-testid='leadsButton'
					>
						Leads
					</div>
					<div
						className={`${styles.selector_btn} ${
							section === 'purchases' && styles.active
						}`}
						data-section='purchases'
						onClick={(e) => handleSection(e)}
					>
						Purchasers
					</div>
				</div>

				<Grid container spacing={3}>
					<Elements stripe={stripePromise}>
						{section === 'leads' && (
							<LeadsSection search={search} />
						)}
						{section === 'purchases' && (
							<PurchasesSection
								search={search}
								checked={checked}
							/>
						)}
					</Elements>
					<Grid item xl={3} lg={3} xs={12}>
						<Grid item xs={12}>
							{user.userType === 'superadmin' ? (
								<Appointments
									salesAgentId={salesAgentId}
									filterByDate={filterByDate}
								/>
							) : (
								<Appointments filterByDate={filterByDate} />
							)}
						</Grid>
						{section !== 'leads' && (
							<Grid item xs={12}>
								<div className={styles.dealStatusTab}>
									<CustomTab
										setTab={setDealStatusTab}
										tab={dealStatusTab}
										items={['Deal Status', 'Pending']}
									/>
								</div>
								{dealStatusTab === 0 ? (
									<>
										{user.userType === 'superadmin' ? (
											<DealStatus
												salesAgentId={salesAgentId}
												filterByDate={filterByDate}
											/>
										) : (
											<DealStatus
												salesAgentId={user.uid}
												filterByDate={filterByDate}
											/>
										)}
									</>
								) : (
									<PendingStatus
										checked={checked}
										setChecked={setChecked}
									/>
								)}
							</Grid>
						)}
					</Grid>
				</Grid>

				<FilterLeads
					openModal={modals.filterLeads}
					filter={leadsFilter}
				/>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	leads: state.leads.leads,
	modals: state.modals,
	loading: state.leads.loading || state.purchasers.loading,
	user: state.signIn,
	leadsFilter: state.filters.leadsFilter,
	filterDealBy: state.leads.filterDealBy,
	section: state.leads.section,
});

export default connect(mapStateToProps, {
	getLeads,
	openModal,
	closeModal,
	clearFilters,
	removeFilter,
	clearDealStatusFilterBy,
	setDealsSection,
})(Deals);
